module.exports = __webpack_public_path__ + "img/GKW_7t.d6f26025.svg";